module.exports = __webpack_public_path__ + "f6073a632e2e222e357bf8bac7f0aac1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/book-stack-s.png
// module id = 2490
// module chunks = 0